import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import EmailService from "../../HttpService/EmailService";
import UserService from '../../HttpService/UsersService';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from "react-router-dom";
import { AuxiliaryService } from "../../HttpService/AuxiliaryService";



const SendMailForm = () => {
    const [recipients, setRecipients] = useState([]);
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [allUsernames, setAllUsernames] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [allOrgs, setAllOrgs] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [allRegs, setAllRegs] = useState([]);
    const [selectedRegs, setSelectedRegs] = useState([]);
    const navigate = useNavigate();

    const getRequests = async () => {
        try {
            const response = await new UserService().getAllUsers();
            return response.data;
        } catch (error) {
            console.log("error listing requests", error);
            throw error;
        }
    }

    useEffect(() => {
        const fetchAllUsernames = async () => {
            try {
                const users = await getRequests();
                const usernames = users.map(usuario => usuario.userName);
                setAllUsernames(usernames);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchAllUsernames();
    }, []);

    useEffect(() => {
        const fetchAllRoles = async () => {
            const roles = await new UserService().getAllRoles();
            setAllRoles(roles.data);
        };
        fetchAllRoles();
    }, []);

    useEffect(() => {
        const fetchAllOrgs = async () => {
            const allOrgs = await new UserService().getAllOrgs();
            setAllOrgs(allOrgs.data);
        };
        fetchAllOrgs();
    }, []);

    useEffect(() => {
        const fetchAllRegs = async () => {
            try {
                const allRegionalPartners = await new AuxiliaryService('auxData/regionalpartner').getAuxiliaries();
                const regionalPartners = allRegionalPartners[0].auxtableDetailsDTOList.map(item => item.txtDescription);
                setAllRegs(regionalPartners);           
            } catch (error) {
                console.error("Error al recuperar datos:", error);
            }
        };
    
        fetchAllRegs();
    }, []);
    


    const handleRecipientChange = (username) => {
        const updatedRecipients = [...recipients];
        if (updatedRecipients.includes(username)) {
            updatedRecipients.splice(updatedRecipients.indexOf(username), 1);
        } else {
            updatedRecipients.push(username);
        }
        setRecipients(updatedRecipients);
    };

    const handleRoleChange = (roleName) => {
        const updatedRoles = [...selectedRoles];
        if (updatedRoles.includes(roleName)) {
            updatedRoles.splice(updatedRoles.indexOf(roleName), 1);
        } else {
            updatedRoles.push(roleName);
        }
        setSelectedRoles(updatedRoles);
    };

    const handleOrgChange = (orgName) => {
        const updatedOrgs = [...selectedOrgs];
        if (updatedOrgs.includes(orgName)) {
            updatedOrgs.splice(updatedOrgs.indexOf(orgName), 1);
        } else {
            updatedOrgs.push(orgName);
        }
        setSelectedOrgs(updatedOrgs);
    };

    const handleRegChange = (regName) => {
        const updatedRegs = [...selectedRegs];
        if (updatedRegs.includes(regName)) {
            updatedRegs.splice(updatedRegs.indexOf(regName), 1);
        } else {
            updatedRegs.push(regName);
        }
        setSelectedRegs(updatedRegs);
    };

    const handleSubjectChange = (event) => {
        setSubject(event.target.value);
    };

    const handleBodyChange = (event) => {
        setBody(event.target.value);
    };

    const handleSendMail = async () => {
        // Mostrar Swal de carga después de 1 segundo
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                //showCancelButton: true,
                //cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }, 5);
    
        try {
            if (recipients.length > 0) {
                const res = await EmailService.sendGroupEmail(recipients, subject, body);
                handleSendMailCallback(res);
            } else if (selectedRoles.length > 0) {
                const res = await EmailService.sendGroupEmailRoles(selectedRoles, subject, body);
                handleSendMailCallback(res);
            } else if (selectedOrgs.length > 0) {
                const res = await EmailService.sendGroupEmailOrgs(selectedOrgs, subject, body);
                handleSendMailCallback(res);
            } else if (selectedRegs.length > 0) {
                const res = await EmailService.sendGroupEmailRegPartners(selectedRegs, subject, body);
                handleSendMailCallback(res);
            } else {
                console.log("No recipients or roles selected");
            }
        } catch (error) {
            console.log(error);
            // Manejar errores y cerrar Swal de carga si se muestra
            clearTimeout(loadingSwalTimeout);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error occurred while sending the email.",
                showConfirmButton: true
            });
        }
    
        // Cerrar Swal de carga si se muestra
        clearTimeout(loadingSwalTimeout);
        Swal.close();
    };

    const handleSendMailCallback = (res) => {
        if (res === "Mail sent to the given address") {
            Swal.fire(
                'Accepted!',
                'The notification has been sent properly.',
                'success'
            )
            navigate("/TODIS-APP/")
        } else {
            console.log("Error accepting the form")
        }
    };

    return (
        <Container fluid className="todis-form-wrapper p-4">
            <Row>
                <Col sm={12}>
                    <h1 className="todis-header text-center" style={{ marginBottom: '20px' }}>Send group notification</h1>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>
                    <Form.Group controlId="formRecipients">
                        <Form.Label style={{ fontWeight: 'bold' }}>Users:</Form.Label>
                        <div style={{ maxHeight: '30vh', overflowY: 'auto', gap: '10px'  }}>
                            {allUsernames.map((username) => (
                                <Form.Check
                                    key={username}
                                    type="checkbox"
                                    label={username}
                                    checked={recipients.includes(username)}
                                    onChange={() => handleRecipientChange(username)}
                                    className="mb-2"
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col sm={3}>
                    <Form.Group controlId="formRoles">
                        <Form.Label style={{ fontWeight: 'bold' }}>Roles:</Form.Label>
                        <div style={{ maxHeight: '30vh', overflowY: 'auto', gap: '10px' }}>
                            {allRoles.map((role) => (
                                <Form.Check
                                    key={role.id}
                                    type="checkbox"
                                    label={role.name}
                                    checked={selectedRoles.includes(role.name)}
                                    onChange={() => handleRoleChange(role.name)}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col sm={3}>
                    <Form.Group controlId="formOrgs">
                        <Form.Label style={{ fontWeight: 'bold' }}>Organizations:</Form.Label>
                        <div style={{ maxHeight: '30vh', overflowY: 'auto', gap: '10px' }}>
                            {allOrgs.map((org) => (
                                <Form.Check
                                    key={org.id}
                                    type="checkbox"
                                    label={org.name}
                                    checked={selectedOrgs.includes(org.name)}
                                    onChange={() => handleOrgChange(org.name)}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col sm={3}>
                    <Form.Group controlId="formRegs">
                        <Form.Label style={{ fontWeight: 'bold' }}>Regional Partners:</Form.Label>
                        <div style={{ maxHeight: '30vh', overflowY: 'auto', gap: '10px' }}>
                            {allRegs.map((reg) => (
                                <Form.Check
                                    key={reg}
                                    type="checkbox"
                                    label={reg}
                                    checked={selectedRegs.includes(reg)}
                                    onChange={() => handleRegChange(reg)}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12} style={{ marginTop: '20px' }}>
                    <Form.Group controlId="formSubject">
                        <Form.Label style={{ fontWeight: 'bold' }}>Subject:</Form.Label>
                        <Form.Control
                            type="text"
                            value={subject}
                            onChange={handleSubjectChange}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Form.Group controlId="formBody">
                        <Form.Label style={{ fontWeight: 'bold' }}>Body:</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={body}
                            onChange={handleBodyChange}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="task-att py-3">
                <Col sm={12} className="d-flex justify-content-end">
                    <Button variant="primary" onClick={handleSendMail}>
                        Send mail
                    </Button>
                </Col>
            </Row>
        </Container>
    );
    
};

export default SendMailForm;